import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import logo from '../../images/logo-1.png'
/* image */
const Img1 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=300&q=80'
const Img2 = 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300&q=80'
const Img3 = 'https://images.unsplash.com/photo-1565793298595-6a879b1d9492?w=300&q=80'
const Img4 = 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=300&q=80'
const Img5 = 'https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=300&q=80'
const Img6 = 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=300&q=80'


const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const footerServices = [
    "Fenetres et portes sur mesure",
    "Volets roulants en aluminium",
    "Murs-rideaux et façades Alucobond",
    "Garde-corps en verre et inox",
];

const Footer = (props) => {


    return (
        <footer className={'' + props.hclass}>
            <div className="wpo-upper-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xl-3 col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget about-widget">
                                <div className="logo">
                                    <Link onClick={ClickHandler} to="/home">
                                        <img src={logo} alt="Leaders Diamant Alu" />
                                    </Link>
                                </div>
                                <p>
                                Leaders Diamant Alu est votre partenaire de confiance en fabrication et installation d’aluminium

                                </p>
                                <ul>
                                    <li>
                                        <a
                                            href="https://www.facebook.com/people/Leaders-Diamant-Aluminium/61585317807425/"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="ti-facebook"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            href="https://www.instagram.com/leaders_diamant_aluminium?igsh=ZzN1d2o4aW1ncG13"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="flaticon-instagram-1"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget link-widget">
                                <div className="widget-title">
                                    <h3>Nos Services</h3>
                                </div>
                                <ul>
                                    {footerServices.map((item, index) => (
                                        <li key={index}>{item}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                        <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget wpo-service-link-widget">
                                <div className="widget-title">
                                    <h3>Nous Contacter</h3>
                                </div>
                                <div className="contact-ft">
                                    <ul>
                                        <li><i className="fi flaticon-location"></i>Chotrana 1 sidi salah , Tunisie</li>
                                        <li><i className="fi flaticon-telephone"></i>+216 27246346 <br />
                                            </li>
                                        <li><i className="fi flaticon-email"></i>contact@diamondalu.tn</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col col-xl-3  col-lg-4 col-md-6 col-sm-12 col-12">
                            <div className="widget instagram">
                                <div className="widget-title">
                                    <h3>Notre Galerie</h3>
                                </div>
                                <ul className="d-flex">
                                    <li><img src={Img1} alt="" /></li>
                                    <li><img src={Img2} alt="" /></li>
                                    <li><img src={Img3} alt="" /></li>
                                    <li><img src={Img4} alt="" /></li>
                                    <li><img src={Img5} alt="" /></li>
                                    <li><img src={Img6} alt="" /></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="wpo-lower-footer">
                <div className="container">
                    <div className="row">
                        <div className="col col-xs-12">
                            <ul>
                                <li>&copy; {new Date().getFullYear()} Diamond Alu. Tous droits réservés.</li>
                                <li><Link onClick={ClickHandler} to='#' >Conditions d'utilisation |</Link> <Link onClick={ClickHandler} to='#' >Politique de confidentialité</Link></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </footer >
    )
}

export default Footer;








